<template>
    <okraina-view :class="'okraina-v-pph'" ref="view" @refresh="refresh" :hideMenu="true"
        :contentHorizontalPadding="19">

        <template v-slot:header>
            <h1>
                Уведомления
            </h1>
        </template>

        <template v-slot:header-right v-if="pushUnreadCount > 0">
            <div class="read-all" @click="readAllConfirm">
                <span class="fi fi-check"></span>
            </div>
        </template>

        <template v-slot:content>

            <div class="spacer"></div>

            <okraina-tabs :items="tabs" v-model="selectedTab" />

            <!--Индикатор загрузки-->
            <transition>
                <okraina-loader-page v-show="loading || !canShow" />
            </transition>

            <!-- Ошибка загрузки -->
            <template v-if="loadingError && !loadingCommon">

                <div class="text-center">
                    Ошибка загрузки данных.
                    <br /><br />
                    <div class="btn btn1" @click="retryLoad">Повторить</div>
                </div>

            </template>

            <template v-if="!loading && canShow">

                <template v-if="reload">
                    <div class="text-center">
                        <okraina-loader-inline />
                    </div>
                </template>

                <template v-else>

                    <div class="list">
                        <okraina-push-history-item v-for="item in items" :key="item.ID" :item="item" />
                    </div>

                    <template v-if="items.length == 0">
                        Список пуст
                    </template>

                    <div ref="pager" class="pager"></div>

                    <!-- Подгрузка следюущей страницы -->
                    <template v-if="loadingPaging">
                        <div class="text-center">
                            <okraina-loader-inline />
                        </div>
                    </template>

                </template>


            </template>

        </template>

    </okraina-view>
</template>

<script>
import okrainaView from "@/components/view2.vue"
import okrainaLoaderPage from "@/components/loader.page.vue";
import okrainaLoaderInline from "@/components/loader.inline.vue";
import okrainaPushHistoryItem from "@/components/personal/push.history.item.vue";
import okrainaTabs from "@/components/tabs.vue";

import rest from "@/plugins/rest";
import bus from "@/plugins/bus";
import moment from "moment";
import meta from "@/plugins/meta";
import metaTemplates from "@/plugins/meta/personal.push.history.js";

import { mapGetters } from "vuex";

export default {
    name: "okraina-v-personal-push-history",
    components: {
        okrainaView,
        okrainaLoaderPage,
        okrainaLoaderInline,
        okrainaPushHistoryItem,
        okrainaTabs
    },
    data() {
        return {
            loading: false,
            reload: false,
            loadingPaging: false,
            loadingCommon: false,
            loadingError: false,

            items: [],
            pager: {
                NUM_PAGE: 1,
                PAGE_SIZE: 20,
                PAGES_COUNT: 1,
            },
            canShow: false,

            selectedTab: "all"
        };
    },

    computed: {

        ...mapGetters({
            regions: "getRegions",
            connection: "getConnection",
            pushUnreadCount: "getPushUnreadCount",
            siteSettings: "getSiteSettings",
        }),

        tabs() {
            let list = [
                {
                    id: "all",
                    name: "все"
                },
            ];

            if (this.siteSettings && this.siteSettings.SCREEN_NOTIFICATIONS_TAB_ACTIONS_ENABLED == "Y") {
                list.push({
                    id: "actions",
                    name: "акции"
                });
            }

            if (this.siteSettings && this.siteSettings.SCREEN_NOTIFICATIONS_TAB_DELIVERY_ENABLED == "Y") {
                list.push({
                    id: "orders",
                    name: "доставка"
                });
            }

            return list;
        },

        filter() {
            let filter = [];

            if (this.selectedTab == "actions") {

                filter.push({
                    "LOGIC": "OR",
                    "TYPE": "ACTION",
                    "%URL": "/clients/actions/"
                });
            } else if (this.selectedTab == "orders") {
                filter.push({
                    "LOGIC": "OR",
                    "TYPE": ["ORDER", "TRACKING"]
                });
            }

            return filter;
        }
    },

    watch: {
        selectedTab: function () {
            this.reload = true;
            this.pager.NUM_PAGE = 1;
            this.loadData();
        },
    },

    methods: {

        /**
         * Загружает данные
        */
        loadData(resolve = false) {

            if (this.loadingCommon) {
                return;
            }
            this.loadingCommon = true;

            rest
                .call("push.history.getlist", {
                    method: "post",
                    data: {
                        NAV_PARAMS: this.pager,
                        FILTER: this.filter
                    },
                })
                .then((data) => {
                    if (data.SUCCESS) {
                        if (this.pager.NUM_PAGE == 1) {
                            this.items = data.ITEMS;
                        } else {
                            this.items = this.items.concat(data.ITEMS);
                        }
                        this.pager = data.PAGER;
                    } else {
                        //показываем сообщение об ошибке
                        bus.emit("OKRAINA_MESSAGE_E_SHOW", { message: data.ERROR_TEXT });
                    }
                })
                .finally(() => {
                    this.loading = false;
                    this.loadingPaging = false;
                    this.loadingCommon = false;
                    this.reload = false;
                    if (resolve) {
                        resolve();
                    }
                });
        },

        /**
         * Повторная попытка загрузки
         */
        retryLoad() {
            if (this.pager.NUM_PAGE == 1) {
                this.loading = true;
            } else {
                this.loadingPaging = true;
            }

            this.loadData();
        },

        /**
         * Перезагрузка экрана
         */
        refresh(resolve) {
            this.reload = true;
            this.pager.NUM_PAGE = 1;
            this.loadData(resolve);
        },

        /**
        * Скрол экрана
        */
        onScroll(e) {
            let scroll = e.target.scrollTop;
            let height = e.target.offsetHeight;
            let offsetTop = this.$refs.pager.offsetTop;

            //если экран прокрутился до пейджера
            if (scroll + height > offsetTop) {
                //если экран не в стадии загрузки и есть следующие страницы
                if (
                    !this.loadingCommon &&
                    !this.loadingPaging &&
                    !this.reload &&
                    this.canShow &&
                    this.pager &&
                    this.pager.NUM_PAGE < this.pager.PAGES_COUNT
                ) {
                    this.pager.NUM_PAGE++;
                    this.loadingPaging = true;
                    this.loadData(() => { });
                }
            }
        },

        /**
         * пометить все сообщения прочитанными
         */
        readAllConfirm() {

            let vm = this;
            //спросим а нужно ли закрывать приложение
            bus.emit("OKRAINA_CONFIRM_E_SHOW", {
                message: "Отметить все уведомления прочитанными?",
                resolveText: "Да",
                rejectText: "Нет",
                resolve: function (value) {
                    if (value) {
                        vm.readAll();
                    }
                },
                reverse: false,
            });

        },

        /**
         * пометить все сообщения прочитанными
         */
        readAll() {
            rest
                .call("push.history.readall", {
                    method: "post",
                    data: {
                    },
                })
                .then((data) => {
                    if (data.SUCCESS) {
                        //перезгрузим данные пользователя
                        this.$store.dispatch("loadUserData");

                        this.items.forEach(item => {
                            item.READ = true;
                        })
                    } else {
                        //показываем сообщение об ошибке
                        bus.emit("OKRAINA_MESSAGE_E_SHOW", { message: data.ERROR_TEXT });
                    }
                });

        },

        /**
         * Трансформируем дату
         */
        formatDate(date) {
            return moment(date, 'DD.MM.YYYY hh:mm:ss').format("DD MMMM YYYY hh:mm");
        },

    },

    /**
     * Вызывается перед переходом из этого экрана в другой
     */
    beforeRouteLeave() {
        this.$refs.view.onBeforeRouteLeave();
    },

    /**
     * Обраотка переход входом на экран
     */
    beforeRouteEnter(to, from, next) {
        //запишем мета данные страницы
        meta.write(metaTemplates);

        next((vm) => {
            vm.$refs.view.onBeforeRouteEnter();
        });
    },

    created() {
        this.loading = true;
        this.loadData();

        //задерживаем показ до завершения перехода на экран (чтобы анимация перехода без тормазов была)
        setTimeout(() => {
            this.canShow = true;
        }, 400);
    },
}
</script>

<style lang="scss">
.okraina-v-pph {

    .read-all {
        padding: 5px 10px;
        font-size: 16px;
        color: var(--color-color1);
    }
}
</style>